import React, { useState } from 'react';
import {
  formatDate,
  formatDateRange,
  formatDateWithoutYear,
} from './accordion-helpers';

const AccordionItem = (props) => {
  const { Begin, Details, End, ServiceName, type } = props;
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const EndedOutages = () => {
    return (
      <div className="accordion__info-item ended-outages">
        {ServiceName && (
          <p className="accordion__info-item--description">{ServiceName}</p>
        )}
        {Begin && (
          <p className="accordion__info-item--date">
            <strong>Starttid: </strong> {formatDate(Begin, true)}
          </p>
        )}
        {End && (
          <p className="accordion__info-item--date">
            <strong>Åtgärdad: </strong> {formatDate(End, true)}
          </p>
        )}
        {Details && (
          <div className="accordion__info-item--details">
            <strong>Detaljerad information:</strong>{' '}
            <div dangerouslySetInnerHTML={{ __html: Details }} />
          </div>
        )}
      </div>
    );
  };

  const PlannedOutages = () => {
    return (
      <div className="accordion__info-item planned-outages">
        {Begin && (
          <p className="accordion__info-item--date">
            <strong>Tid: </strong> {formatDateRange(Begin, End)}
          </p>
        )}
        {Details && (
          <span className="accordion__info-item--details">
            <div dangerouslySetInnerHTML={{ __html: Details }} />
          </span>
        )}
      </div>
    );
  };

  const renderOutageTypeContent = () => {
    return type === 'Ended' ? <EndedOutages /> : <PlannedOutages />;
  };

  return (
    <div className={`ids-expandable ${
      isOpen ? 'ids-expandable--expanded' : ''
    }`}>
      <div
        onClick={toggleAccordion}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleAccordion();
          }
        }}
        className="ids-expandable__button"
        role="button"
        tabIndex="0"
        aria-expanded={isOpen}
        aria-controls="ids-expandable__content"
      >
        <div className="ids-expandable__inner">
          <h3 className="ids-expandable__headline">
            {formatDateWithoutYear(Begin) + ' - ' + ServiceName}
          </h3>
          <span
            className={`ids-expandable__icon ${
              isOpen ? 'ids-expandable__icon--opened' : ''
            }`}
          ></span>
        </div>
      </div>
      {isOpen && (
        <div className="ids-expandable__content" id="ids-expandable__content" aria-hidden={!isOpen}>
          {renderOutageTypeContent()}
        </div>
      )}
    </div>
  );
};

export default AccordionItem;
